import { toast } from "react-toastify";
import { BLOCK_FADV_REQUESTOR } from "config/apiEndPoint";
import { GET, POST } from "config/api.config";

export const fetchBlockFadvRequestorMetadata = async (data = {}) => {
    try {
        const response = await GET(BLOCK_FADV_REQUESTOR.GET_METADATA, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const submitBlockFadvRequestorFilterData = async (data = {}) => {
    try {
        const response = await POST(BLOCK_FADV_REQUESTOR.SUBMIT_FILTER_DATA, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

const normalizeToggleBlockFadvRequestorId = (value) => {
    if (value === null || value === undefined) return null;
    const normalized = String(value).trim();
    return normalized === "" ? null : normalized;
};

export const toggleBlockFadvRequestor = async (data = {}) => {
    try {
        const response = await POST(BLOCK_FADV_REQUESTOR.TOGGLE_BLOCKED, {
            blockFadvRequestorId: normalizeToggleBlockFadvRequestorId(data?.blockFadvRequestorId),
            fadvOrderDataDetailsId: String(data?.fadvOrderDataDetailsId ?? ""),
            isBlocked: Boolean(data?.isBlocked),
        });
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
